export enum Language {
  EN = 'en',
  NL = 'nl',
}

export enum ApiDetailTab {
  FEATURES = 'Features',
  GUIDES = 'Guides',
  SPECS = 'Specs',
}

export enum ApiFeatureTab {
  DEMO = 'Demo',
}
